var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.345 2.137a.5.5 0 1 0-.688.726L10.445 5.5H.5a.5.5 0 0 0 0 1h9.945L7.657 9.137a.5.5 0 1 0 .688.726l3.316-3.137a1 1 0 0 0 0-1.452z",
    clipRule: "evenodd"
  })));
});
const SvgArrowRightsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRightsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjM0NDU4IDIuMTM2NzdDOC4xNDM5NyAxLjk0NyA3LjgyNzUxIDEuOTU1NzkgNy42Mzc3NCAyLjE1NjRDNy40NDc5OCAyLjM1NzAxIDcuNDU2NzcgMi42NzM0NyA3LjY1NzM4IDIuODYzMjRMMTAuNDQ0OCA1LjVIMC41QzAuMjIzODU4IDUuNSAwIDUuNzIzODYgMCA2QzAgNi4yNzYxNCAwLjIyMzg1OCA2LjUgMC41IDYuNUgxMC40NDQ4TDcuNjU3MzggOS4xMzY3N0M3LjQ1Njc3IDkuMzI2NTMgNy40NDc5OCA5LjY0Mjk5IDcuNjM3NzQgOS44NDM2QzcuODI3NTEgMTAuMDQ0MiA4LjE0Mzk3IDEwLjA1MyA4LjM0NDU4IDkuODYzMjRMMTEuNjYwNiA2LjcyNjQ3QzEyLjA3NzcgNi4zMzE5NSAxMi4wNzc3IDUuNjY4MDYgMTEuNjYwNiA1LjI3MzUzTDguMzQ0NTggMi4xMzY3N1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";